import { render, staticRenderFns } from "./SpotsOrders.vue?vue&type=template&id=54ca4b71&scoped=true&"
import script from "./SpotsOrders.vue?vue&type=script&lang=js&"
export * from "./SpotsOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ca4b71",
  null
  
)

export default component.exports